import { UploadEntity } from "~/interfaces/entities/Upload"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: uploads,
  selectors: uploadsSelectors,
} = createEntitySlice<UploadEntity>("uploads")
